import init from './init';
import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Redirect, Route, Switch } from 'react-router-dom';
import Rails from './layouts/rails';
import _ from 'lodash';
import 'moment/locale/ja'; // momentjs language support
import Moment from 'moment';

import './styles/app.css';
import ModalDialog from './components/modalDialog';
import { RelayPoint } from './components/RelayPoint';
import { DirectOauth } from './components/DirectOauth';
import { LoginDispatcher } from './components/LoginDispatcher';
import { LoginCallback } from './components/LoginCallback';

// Error Pages
import { Error500 } from './pages/Error500';
import { logout } from './pages/logout';
import { ErrorPermission } from './pages/ErrorPermission';
import { NotFound } from './pages/NotFound';
import { Maintenance } from './pages/Maintenance';

import LayoutPrint from './pages/LayoutPrint';

import InvitedUserProfileForm from './pages/InvitedUserProfileForm';
import history from './utilities/history';
import AuthProvider from './utilities/authProvider';
import ErrorBoundary from './components/ErrorBoundary';

import SessionStorageService from './services/utilities/SessionStorageService';
import LocalStorageService from './services/utilities/LocalStorageService';

import { isTargetRoleId } from './utilities/roleUtility';
import {
  USER_ROLES,
  DOES_NOT_UPDATE_OWN_PASSWORD,
} from './utilities/constants';
import { updateDataLayer } from './utilities/gtm';
import { messageUtility } from './utilities/messageUtility';

// google tag manager
updateDataLayer();
init();


/**
 * iPad safariでCSSのvhの判定が難しいため、jsで計算したものを使用して対策する
 *
 **/
const setVh = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
};
window.addEventListener('load', setVh);
window.addEventListener('resize', setVh);

const authProvider = AuthProvider.instance;

/**
 * URLから直接アクセス時、想定したrole_idが設定されているかの確認用
 * エラーページを出力しないようtry catchしている
 */
const hasRoleId = () => {
  const roleId = LocalStorageService.getRoleId();
  const userRoleKeyArray = Object.values(USER_ROLES);
  try {
    if (isTargetRoleId(userRoleKeyArray, roleId)) {
      return true;
    }
  } catch (e) {
    return false;
  }
  return false;
};

const Routing = () => {
  Moment.locale('ja');
  var ua = navigator.userAgent.toLowerCase();
  //iOS
  if (
    (ua.indexOf('ipod') >= 0 ||
      ua.indexOf('iphone') >= 0 ||
      ua.indexOf('ipad') >= 0) &&
    ua.indexOf('safari') >= 0
  ) {
    const stopVersion = '11';
    if (
      ua
        .split('os')[1]
        .trim()
        .indexOf(stopVersion) === 0
    ) {
      //iOS11以上、Safari用の処理
      document.addEventListener(
        'touchmove',
        function(event) {
          if (event.touches.length >= 2) {
            event.preventDefault();
          }
        },
        { passive: false }
      );
    }
  }

  return (
    <div>
      <ErrorBoundary>
        <Switch>
          <Route exact={true} path='/maintenance' component={Maintenance} />
          <Route exact={true} path='/error-500' component={Error500} />
          {/*500*/}
          <Route
            exact={true}
            path='/error-permission'
            component={ErrorPermission}
          />
          {/* 招待ユーザでユーザ情報が未登録(パスワードが初期パスワードから未変更)の時のみRoutingされる */}
          <Route
            exact
            path='/user-edit'
            render={() => {
              if (
                SessionStorageService.getItem('isEmpty') ===
                DOES_NOT_UPDATE_OWN_PASSWORD
              ) {
                return <InvitedUserProfileForm view={{ state: { id: 1 } }} />;
              } else {
                return <NotFound />;
              }
            }}
          />
          <Route
            exact
            path='/relay_point'
            render={() => <RelayPoint authProvider={authProvider} />}
          />
          {/*direct認証専用の直リンク*/}
          <Route
            exact
            path='/direct_oauth/callback/:parameter/:loginId'
            render={routeProps => (
              <DirectOauth authProvider={authProvider} {...routeProps} />
            )}
          />
          <Route
            exact
            path='/'
            render={() => <LoginDispatcher authProvider={authProvider} />}
          />
          <Route
            exact
            path='/callback'
            render={() => <LoginCallback authProvider={authProvider} />}
          />
          {/* 招待ユーザでユーザ情報が未登録(パスワードが初期パスワードから未変更)の時のみ登録画面へリダイレクトされる */}
          {SessionStorageService.getItem('isEmpty') ===
            DOES_NOT_UPDATE_OWN_PASSWORD && <Redirect to='/user-edit' />}
          <Route
            exact
            path={'/conference/:master/:slide1/:slide2/:url1/:url2'}
            render={props => {
              if (hasRoleId()) {
                return <Rails {...props} />;
              } else {
                if (SessionStorageService.getToken()) {
                  authProvider.logout();
                  return null;
                }
                return <Redirect to='/' />;
              }
            }}
          />
          <Route
            exact
            path={'/gatekeeper/:master/:slide1/:slide2/:url1/:url2'}
            render={props => <Rails {...props} />}
          />
          {/*入退場管理*/}
          <Route
            exact
            path={'/roan/:master/:slide1/:slide2/:url1/:url2'}
            render={props => <Rails {...props} />}
          />
          {/*現場配置印刷中*/}
          <Route exact path={'/LayoutPrint'} component={LayoutPrint} />
          {/*出力中*/}
          <Route
            exact
            path={'/FileOutput'}
            render={() => (
              <LayoutPrint message={messageUtility.getMessage('I-000-107')} />
            )}
          />
          {/*PDF出力中*/}
          <Route
            exact
            path={'/LayoutPrintQR'}
            render={() => (
              <LayoutPrint message={messageUtility.getMessage('I-000-253')} />
            )}
          />
          {/* sessionストレージのクリア*/}
          <Route exact={true} path='/conference/logout' component={logout} />
          <Route
            exact
            path={'/progress/:master/:slide1/:slide2/:url1/:url2'}
            render={props => <Rails {...props} />}
          />
          <Route
            path={'/tracker'}
            render={props => <Rails {...props} />}
          />
          <Route component={NotFound} /> {/*404*/}
        </Switch>
      </ErrorBoundary>
    </div>
  );
};
ReactDOM.render(
  <Router history={history}>
    <div>
      <Routing />
      <ModalDialog />
    </div>
  </Router>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js